module.exports = __webpack_public_path__ + "static/media/stop-2.0e5fcd51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-2.svg
// module id = 1369
// module chunks = 0